import { FC } from 'react'

import { Flex } from '@revolut-internal/ui-kit'

import { DataTile } from 'components/DataTile/DataTile'
import { DataTileSkeleton } from 'components/DataTile/DataTileSkeleton'
import { useChannel } from 'hooks/useChannel'
import { QueueHealthMetricsOverview } from 'types'
import { formatDuration, Formats } from 'utils/formatTimeAndDuration'
import { pluralize } from 'utils/pluralize'

const QueuesHealthDetailsMetricsSkeleton = () => (
  <Flex gap="s-16" flexWrap="wrap">
    <DataTileSkeleton />
    <DataTileSkeleton />
    <DataTileSkeleton />
  </Flex>
)

type QueuesHealthDetailsMetricsProps = {
  metrics?: QueueHealthMetricsOverview
  isPending: boolean
}

export const QueuesHealthDetailsMetrics: FC<QueuesHealthDetailsMetricsProps> = ({
  metrics,
  isPending,
}) => {
  const { entityName, specialisationLabel } = useChannel()

  if (isPending) {
    return <QueuesHealthDetailsMetricsSkeleton />
  }

  if (!metrics) {
    return null
  }

  const formattedMaxQwt = formatDuration(metrics.maxQwt.value, {
    format: Formats.Tuple,
  })

  return (
    <Flex gap="s-16" flexWrap="wrap">
      <DataTile
        header="Unassigned"
        mainValue={{
          value: metrics.unassignedTicketCount.value,
          unit: pluralize(entityName, metrics.unassignedTicketCount.value, true),
        }}
        hasBreach={metrics.unassignedTicketCount.slaBreach}
      />
      <DataTile
        header="Max waiting time"
        mainValue={formattedMaxQwt.map(([value, unit]) => ({ value, unit }))}
        hasBreach={metrics.maxQwt.slaBreach}
      />
      <DataTile
        header="Breached QWT"
        mainValue={{
          value: metrics.breachedQwt.ticketCount,
          unit: pluralize(entityName, metrics.breachedQwt.ticketCount, true),
        }}
        extraValue={`${metrics.breachedQwt.specialisationCount} ${pluralize(specialisationLabel, metrics.breachedQwt.specialisationCount, true)}`}
        hasBreach={metrics.breachedQwt.slaBreach}
      />
    </Flex>
  )
}
